import { SocialIcon } from "react-social-icons";
import { Link } from "react-router-dom";

export default function Header(): JSX.Element {
  return (
    <div className="HeaderContainer">
      <ul>
        <li>
          <Link to="/Projects" id="Link">
            Projects
          </Link>
        </li>
        <li>
          <Link to="/AboutMe" id="Link">
            About Me
          </Link>
        </li>
        <li>
          <a href="/files/Fola Akinwale CV 2023.pdf" download id="Link">
            CV
          </a>
        </li>
        <li>
          <SocialIcon url="https://www.linkedin.com/in/jimi-akinwale-33956018a/" />
        </li>
        <li>
          <SocialIcon url="https://github.com/FolaJ-Akin" />
        </li>
        <li>
          <SocialIcon url="https://discord.com/users/King_Akz#1239/" />
        </li>
      </ul>
    </div>
  );
}
